var file_upload_viewer_default = {
  "fontElementMap": "_6r8R-",
  "file_upload_container": "gmL3j",
  "file_upload_link": "AhcQP",
  "file_upload_error_container": "_9RuKB",
  "file_upload_file_info": "sS1oB",
  "file_upload_type_icon": "zpDqy",
  "file_upload_status_icon_container": "_5G-PN",
  "file_upload_status_icon": "vD1Be",
  "file_upload_description": "bZgjn",
  "file_upload_name_container": "zfJX6",
  "file_upload_name": "lytNo",
  "file_upload_extension": "_7oZxE",
  "file_loader_icon": "_2Hip0",
  "file_upload_icon_frame": "zggga",
  "file_upload_icon_background": "kPrKc"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
